import React from 'react';
import { Button } from './ui/button';
import { TrendingUp, Award, Users } from 'lucide-react';
import { stats } from '../data/mock';

const iconMap = {
  TrendingUp: TrendingUp,
  Award: Award,
  Users: Users
};

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1758952323571-659083edd03a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwc2t5bGluZXxlbnwwfHx8fDE3NjgwODk4ODR8MA&ixlib=rb-4.1.0&q=85)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-700/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 animate-fade-in">
          Elevate Your Real Estate Success
        </h1>
        <p className="text-xl md:text-2xl text-white mb-4 font-semibold">
          Managed Real Estate Success
        </p>
        <p className="text-lg text-white/90 mb-12 max-w-3xl mx-auto">
          From strategic investments to expert brokerage and comprehensive property management,
          RISE Real Estate Group delivers results that exceed expectations.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button
            size="lg"
            onClick={() => scrollToSection('contact')}
            className="bg-white text-blue-600 hover:bg-gray-100 text-lg px-8 py-6 h-auto"
          >
            Get Started
            <span className="ml-2">→</span>
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => scrollToSection('investments')}
            className="border-2 border-white text-white hover:bg-white hover:text-blue-600 text-lg px-8 py-6 h-auto bg-transparent"
          >
            Learn More
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => scrollToSection('team')}
            className="border-2 border-white text-white hover:bg-white hover:text-blue-600 text-lg px-8 py-6 h-auto bg-transparent"
          >
            Our Agents
          </Button>
        </div>

        {/* Service Navigation Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-20">
          <Button
            size="lg"
            variant="outline"
            onClick={() => scrollToSection('investments')}
            className="border-2 border-white/60 text-white hover:bg-white hover:text-blue-600 text-base px-6 py-5 h-auto bg-transparent"
          >
            Investments
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => scrollToSection('brokerage')}
            className="border-2 border-white/60 text-white hover:bg-white hover:text-blue-600 text-base px-6 py-5 h-auto bg-transparent"
          >
            Brokerage
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => scrollToSection('property-management')}
            className="border-2 border-white/60 text-white hover:bg-white hover:text-blue-600 text-base px-6 py-5 h-auto bg-transparent"
          >
            Property Management
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => window.open('https://www.tenantcloud.com/tenant', '_blank')}
            className="border-2 border-white/60 text-white hover:bg-white hover:text-blue-600 text-base px-6 py-5 h-auto bg-transparent"
          >
            Resident Portal
          </Button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-6 text-left hover:bg-white/15 transition-all duration-300"
              >
                <Icon className="w-8 h-8 text-white mb-3" />
                <div className="text-3xl font-bold text-white mb-2">{stat.value}</div>
                <div className="text-white/80 text-sm">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Hero;